import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import axios from "axios"; import Cookies from "js-cookie";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import {InputSwitch} from "primereact/inputswitch";
import {InputNumber} from "primereact/inputnumber";

const _FM_SettingsFormComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "settings/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderChanelList: true,
            selectedChanelId: response.data.data.id
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarChanelForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "settings/1",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "settings/1",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setFormData(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('settings_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>

                <div className={"p-col-12"}>
                  <Field name="automatic_daily_close_case_of_out_of_order" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"automatic_daily_close_case_of_out_of_order"}/>
                      <label htmlFor="automatic_daily_close_case_of_out_of_order"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('automatic_daily_close_case_of_out_of_order')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"automatic_daily_close_case_of_out_of_order"}
                        checked={formData.automatic_daily_close_case_of_out_of_order}
                        onChange={(e) => {
                            setFormData({
                              ...formData,
                              automatic_daily_close_case_of_out_of_order: e.value
                            })
                            setNewFormData({
                              ...newFormData,
                              automatic_daily_close_case_of_out_of_order: e.value
                            })
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="automatic_daily_close_case_of_no_happening" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"automatic_daily_close_case_of_no_happening"}/>
                      <label htmlFor="automatic_daily_close_case_of_no_happening"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('automatic_daily_close_case_of_no_happening')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"automatic_daily_close_case_of_no_happening"}
                        checked={formData.automatic_daily_close_case_of_no_happening}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            automatic_daily_close_case_of_no_happening: e.value
                          })
                          setNewFormData({
                            ...newFormData,
                            automatic_daily_close_case_of_no_happening: e.value
                          })
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="automatic_daily_close_without_condition" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"automatic_daily_close_without_condition"}/>
                      <label htmlFor="automatic_daily_close_without_condition"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('automatic_daily_close_without_condition')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"automatic_daily_close_without_condition"}
                        checked={formData.automatic_daily_close_without_condition}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            automatic_daily_close_without_condition: e.value
                          })
                          setNewFormData({
                            ...newFormData,
                            automatic_daily_close_without_condition: e.value
                          })
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>





                <div className={"p-col-12"}>
                  <Field name="guest_data_from_guest_request" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"guest_data_from_guest_request"}/>
                      <label htmlFor="guest_data_from_guest_request"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('guest_data_from_guest_request')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"guest_data_from_guest_request"}
                        checked={formData.guest_data_from_guest_request}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            guest_data_from_guest_request: e.value
                          })
                          setNewFormData({
                            ...newFormData,
                            guest_data_from_guest_request: e.value
                          })
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="api" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"api"}/>
                      <label htmlFor="api"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('api')}</label>
                      <span className="p-d-block">
                      <InputSwitch
                        className={"p-mt-1"}
                        name={"api"}
                        checked={formData.api}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            api: e.value
                          })
                          setNewFormData({
                            ...newFormData,
                            api: e.value
                          })
                        }}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3"}>
                  <Field name="child_age_limit" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"child_age_limit"}/>
                      <label htmlFor="child_age_limit"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('child_age_limit')}</label>
                      <span className="p-d-block">
                      <InputText id="child_age_limit" {...input}
                                   keyfilter={"num"}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       child_age_limit: e.target.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       child_age_limit: e.target.value
                                     })
                                   }}
                                   value={formData.child_age_limit}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>



              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
      <div className={"p-mt-2"}>
        <i className={"pi pi-exclamation-circle"}></i>
        &nbsp;
        {t('form_under_edit')}
        {formData && formData.under_edit_by_name_snap &&
        <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
        }
      </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_SettingsFormComponent);
